module.exports = __webpack_public_path__ + "img/ceramics2.fe909f6b.jpg";